import { useTranslation } from "react-i18next";

import {
  PositionPostSchema,
  PositionPutSchema,
  useCreatePosition,
  useUpdatePosition,
} from "~/entity/Positions";
import { useNotify } from "~/shared/hooks/useNotify";

export const defaultValues = {
  id: "",
  code: "",
  name: "",
  status: undefined,
  updatedAt: "",
  createdAt: "",
  DirectionId: undefined,
  RequiredEmail: false,
  showInZd: false,
  jobDescriptionIsRequired: false,
};

export const positionQueryManagement = ({ refetch, closeModal }) => {
  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();
  const { create } = useCreatePosition();
  const { update } = useUpdatePosition();

  const onSuccess = async () => {
    await refetch();
    closeModal();
    notifySuccess(t("common.сhange_was_successful"));
  };

  const onError = (error) => {
    notifyError(error?.message || "Ошибка выполнения запроса");
  };

  const editPosition = (
    instanceId: number | string,
    data: PositionPutSchema,
  ) => {
    update(instanceId, data, { onSuccess, onError });
  };

  const addPosition = (data: PositionPostSchema) => {
    create(data, { onSuccess, onError });
  };

  return { editPosition, addPosition };
};
